import { SIZES } from "../constants";
import getPreviewModalMaxSize from "./getPreviewModalMaxSize";
export default (src, successCallback, errorCallback) => {
    const img = new Image();
    img.onload = function () {
        const ratio = img.width / img.height;
        const { maxHeight, maxWidth } = getPreviewModalMaxSize(true);
        let height = Math.max(SIZES.PREVIEW_MIN_HEIGHT, Math.min(maxHeight, img.height));
        let width = height * ratio;
        if (width > maxWidth) {
            width = maxWidth;
            height = width / ratio;
        }
        successCallback(width, height);
    };
    img.onerror = function () {
        errorCallback();
    };
    img.src = src;
};
